import React from "react";
// import { Link } from "react-router-dom";

import { Theme, useTheme } from "@mui/material/styles";

import Link from "@mui/material/Link";

import { Container, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import useMediaQuery from "@mui/material/useMediaQuery";

export default function AppFooter() {
	///
	/// AppContexto
	///
	const _appTema: Theme = useTheme();

	///
	/// State
	///

	const classes = useStyles();
	const maxWidthTitulo = useMediaQuery("(max-width:420px)");

	return (
		<Box sx={classes.box}>
			<Container sx={classes.container}>
				<Typography sx={classes.texto}>
					@{new Date().getFullYear()} &nbsp;&nbsp;
					<Link
						href="https://arteh.com.au"
						sx={classes.link}
						target="_blank"
					>
						ARTEH
					</Link>
					&nbsp;&nbsp;
					{maxWidthTitulo
						? ""
						: "Business as a force for a net-zero future"}
				</Typography>
			</Container>
		</Box>
	);
}

const useStyles = () => {
	const _theme = useTheme();
	return {
		box: {
			marginTop: "3rem",
			padding: 8,
			boxShadow:
				"0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)",
		},
		container: {
			top: "auto",
			bottom: 0,
		},
		texto: {
			fontSize: "0.8rem",
			textAlign: "right",
		},
		link: {
			color: "#1c3387",
			fontWeight: "bold",
		},
	};
};
